
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exhibitions-and-events/learning/[slug]",
      function () {
        return require("private-next-pages/exhibitions-and-events/learning/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exhibitions-and-events/learning/[slug]"])
      });
    }
  